import {createFileRoute} from "@tanstack/react-router";

import {DevelopmentDashboardPage} from "./-page/development-dashboard.page";

export const Route = createFileRoute("/_app/dev/dashboard/")({
  component: DevelopmentDashboardPage,
  staticData: {
    meta: {
      label: "Development dashboard",
      nav: {visible: false},
    },
  },
});
